import { render, staticRenderFns } from "./SplitRoom.vue?vue&type=template&id=62a698e6&"
import script from "./SplitRoom.vue?vue&type=script&lang=js&"
export * from "./SplitRoom.vue?vue&type=script&lang=js&"
import style0 from "./SplitRoom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports